import {LastCallError} from './LastCallError.js'

export class InvalidUserError extends LastCallError {
  constructor({errorType, detail}) {
    super({errorType, detail})
  }
}
